import BaseAbility from 'umg-ember-backend/abilities/base';

export default class ContestEntryAbility extends BaseAbility {
  // Getter and setter
  get canCreate() {
    return false;
  }

  get permissions() {
    return this.permission.for('contest');
  }
}
